// To tree-shake the server-side code from the browser bundle.
export default typeof window === 'undefined'
  ? require('./get-server-host.ts').default
  : require('./get-client-host.ts').default;
